import name from './name';
import dimensions from './dimensions';
import { actions } from './actions';
import weight from './weight';
import domesticService from './domesticService';
import domesticProvider from './domesticProvider';
import domesticPackage from './domesticPackage';
import domesticConfirmation from './domesticConfirmation';
import internationalService from './internationalService';
import internationalProvider from './internationalProvider';
import internationalPackage from './internationalPackage';
import internationalConfirmation from './internationalConfirmation';

export default {
  name,
  dimensions,
  weight,
  domesticProvider,
  domesticService,
  domesticPackage,
  domesticConfirmation,
  internationalProvider,
  internationalService,
  internationalPackage,
  internationalConfirmation,
  actions,
};
